import React from "react";
import { Switch, Route } from "react-router-dom";
import SocialMedia from "./SocialMedia";
// import Projects from "./Projects";
import Nav from "./Nav";
import ExploreTeam from "./ExploreTeam";
import Home from "./Home";
import Team from "./Team";
// import Background from "./Background";
import TeamEvent from "./TeamEvent";
import Events from "./Events";
import Footer from "./Footer";
import Contact from "./Contact";
const App = () => {
  return (
    <div className="relative overflow-hidden min-h-screen sun dark:moon">
      {/* <Background repeat={10} /> */}
      <Nav />
      <SocialMedia />
      <Switch>
        <Route path="/contact">
          <Contact />
        </Route>
        <Route
          path={["/events/:id/:id", "/events/:id"]}
          component={TeamEvent}
        />
        <Route exact path="/events">
          <Events />
        </Route>
        <Route path="/team/explore/:id" component={ExploreTeam} />
        <Route path="/team">
          <Team />
        </Route>
        {/* <Route path="/projects">
          <Projects />
        </Route> */}
        <Route exact path="/home" component={Home} />
        <Route exact path="/" component={Home} />
      </Switch>
      <Footer />
    </div>
  );
};
export default App;
